import { STEPS_INTL_1 } from 'cohorts/intl_1/constants/steps'
import { STEPS_INTL_1T } from 'cohorts/intl_1t/constants/steps'
import { STEPS_INTL_2 } from 'cohorts/intl_2/constants/steps'
import {
  getFirstRoutePageIdIntl2Lw,
  getStepsIntl2Lw,
} from 'cohorts/intl_2lw/helpers/getFirstScreenVariant'
import { STEPS_INTL_D60 } from 'cohorts/intl_d60/constants/steps'
import { STEPS_INTL_D70 } from 'cohorts/intl_d70/constants/steps'
import { STEPS_INTL_HLWN70 } from 'cohorts/intl_hlwn70/constants/steps'
import { STEPS_INTL_MW } from 'cohorts/intl_mw/constants/steps'
import { STEPS_INTL_3 } from 'cohorts/intl_3/constants/steps'
import React, {
  lazy,
  type LazyExoticComponent,
  type PropsWithChildren,
} from 'react'
import { Cohort } from 'root-constants'

export const DYNAMIC_COMPONENTS_MAP: Record<
  Cohort,
  {
    RoutesList: LazyExoticComponent<React.FC>
    Header: LazyExoticComponent<React.FC>
    BgPreloadingMediaProvider?: LazyExoticComponent<React.FC<PropsWithChildren>>
  }
> = {
  [Cohort.INTL_1]: {
    RoutesList: lazy(() =>
      import('components/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_INTL_1,
          }),
      })),
    ),
    Header: lazy(() =>
      import('cohorts/intl_1/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('cohorts/intl_1/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderIntl1,
      })),
    ),
  },
  [Cohort.INTL_1T]: {
    RoutesList: lazy(() =>
      import('components/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_INTL_1T,
          }),
      })),
    ),
    Header: lazy(() =>
      import('cohorts/intl_1t/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('cohorts/intl_1t/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderIntl1T,
      })),
    ),
  },
  [Cohort.INTL_2]: {
    RoutesList: lazy(() =>
      import('components/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_INTL_2,
          }),
      })),
    ),
    Header: lazy(() =>
      import('cohorts/intl_2/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('cohorts/intl_2/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderIntl2,
      })),
    ),
  },
  [Cohort.INTL_2LW]: {
    RoutesList: lazy(() =>
      import('components/RoutesList').then((m) => ({
        // Evaluated at render time (after SubscribeFlow's flow-variant gate),
        // so abtest_web_127_first_screen group C gets its own step list.
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: getStepsIntl2Lw(),
            firstPageId: getFirstRoutePageIdIntl2Lw(),
          }),
      })),
    ),
    Header: lazy(() =>
      import('cohorts/intl_2lw/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('cohorts/intl_2lw/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderIntl2Lw,
      })),
    ),
  },
  [Cohort.INTL_D60]: {
    RoutesList: lazy(() =>
      import('components/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_INTL_D60,
          }),
      })),
    ),
    Header: lazy(() =>
      import('cohorts/intl_d60/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('cohorts/intl_d60/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderIntlD60,
      })),
    ),
  },
  [Cohort.INTL_D70]: {
    RoutesList: lazy(() =>
      import('components/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_INTL_D70,
          }),
      })),
    ),
    Header: lazy(() =>
      import('cohorts/intl_d70/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('cohorts/intl_d70/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderIntlD70,
      })),
    ),
  },
  [Cohort.INTL_HLWN70]: {
    RoutesList: lazy(() =>
      import('components/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_INTL_HLWN70,
          }),
      })),
    ),
    Header: lazy(() =>
      import('cohorts/intl_hlwn70/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('cohorts/intl_hlwn70/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderIntlHlwn70,
      })),
    ),
  },
  [Cohort.INTL_MW]: {
    RoutesList: lazy(() =>
      import('components/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_INTL_MW,
          }),
      })),
    ),
    Header: lazy(() =>
      import('cohorts/intl_mw/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('cohorts/intl_mw/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderIntlMw,
      })),
    ),
  },
  [Cohort.INTL_3]: {
    RoutesList: lazy(() =>
      import('components/RoutesList').then((m) => ({
        default: (props) =>
          React.createElement(m.RoutesList, {
            ...props,
            steps: STEPS_INTL_3,
          }),
      })),
    ),
    Header: lazy(() =>
      import('cohorts/intl_3/components/header/Header').then((m) => ({
        default: m.Header,
      })),
    ),
    BgPreloadingMediaProvider: lazy(() =>
      import('cohorts/intl_3/BgPreloadingMediaProvider').then((m) => ({
        default: m.BgPreloadingMediaProviderIntl3,
      })),
    ),
  },
}
